/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import type { ICellRendererParams } from 'ag-grid-community'
import { Link } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import type { UserRegistration } from '@sportninja/common/hooks/useUserRegistrationData'
import { formatShortDate } from '@sportninja/common/ts-utils/date-utils'
import Text from 'src/components/ts-components/Text'

/** The competition's name, linked to its schedule, over its dates. */
const CompetitionCell = ({
  data: record,
}: ICellRendererParams<UserRegistration>) => {
  if (!record) {
    return null
  }

  const teamQuery = record.team?.uid ? `?sn_team=${record.team.uid}` : ''

  return (
    <div css={stackStyle}>
      <Text
        variant='paragraphSmall'
        weight='regular'
        color={colors.WHITE}
        style={TWO_LINES}
      >
        <Link
          to={`${ROUTES.SCHEDULE_ROOT}/${record.schedule.uid}${teamQuery}`}
          css={linkStyle}
        >
          {record.schedule.name}
        </Link>
      </Text>
      <Text
        variant='paragraphXSmall'
        weight='regular'
        color={colors.NEUTRAL_50}
      >
        {formatShortDate(record.schedule.start_date)} -{' '}
        {formatShortDate(record.schedule.end_date)}
      </Text>
    </div>
  )
}

export default CompetitionCell

// ─── Styles ──────────────────────────────────────────────────────

const TWO_LINES = `
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

const stackStyle = css`
  min-width: 0;
  line-height: 20px;
  white-space: normal;
`

const linkStyle = css`
  &:hover {
    text-decoration: underline;
  }
`
